import { render } from "./Matches.vue?vue&type=template&id=48f88c8a"
import script from "./Matches.vue?vue&type=script&lang=js"
export * from "./Matches.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__